import React, { useState, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Form, ConfigProvider } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import api from '../../services/api'
import styles from '../../services/styles'
import { displayMessage } from '../../helpers/messages'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import SL_Button from '../../components/buttons/Button'
import { SL_Input } from '../../components/input/Input'

const { tc1, tc2, bc1, bc2, bc4, bc7, COLORS } = styles

export const ResetPasswordForm = () => {
    const { token } = useParams()

    const {
        mobile_mode
    } = useContext(GeneralContext)

    const onFinish = async (values) => {
        try {
            await api.auth.resetPasswordForced(values, token)

            alert(displayMessage('REDIRECTING_TO_LOGIN'), 'success', displayMessage('SUCCESS'))

            setTimeout(() => {
                window.location.href = window.location.origin + '/login'
            }, 3000)
        } catch (e) {
        }
    }

    return (
        <>
            <div
                style={{
                    color: tc1,
                    fontWeight: 'bold',
                    marginBottom: 15,
                    fontSize: mobile_mode ? 20 : 24,
                    textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                    color: bc2,
                }}
            >
                {displayMessage('CHANGE_PASSWORD_TITLE') + 'asodasod'}
            </div>

            <Form
                onFinish={onFinish}
            
                style={{ maxWidth: 400, width: '100%', background: 'black' }}
                layout='vertical'
            >
                <ConfigProvider
                    theme={{
                        token: {
                            colorError: COLORS.RED[650]  // Mantém vermelho para erros de validação
                        },
                    }}
                >
                    <div style={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
                        <div
                            style={{
                                color: COLORS.GRAY[50],
                                textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                                fontWeight: 'bold',
                                display: 'flex'
                            }}>
                            {displayMessage('NEW_PASSWORD_SHORT')}
                        </div>

                        <Form.Item
                            name="newPassword"
                            rules={[{ required: true, message: displayMessage('DISPLAY_NEW_PASSWORD_SHORT') }]}
                            style={{ marginBottom: 15 }}
                        >
                            <SL_Input
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                type="password"
                                placeholder={displayMessage('ENTER_NEW_PASSWORD_SHORT')}
                            />
                        </Form.Item>
                    </div>

                    <div style={{ display: 'flex', gap: 2, flexDirection: 'column', marginTop: 5 }}>
                        <div
                            style={{
                                color: COLORS.GRAY[50],
                                textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                                fontWeight: 'bold',
                                display: 'flex'
                            }}>
                            {displayMessage('NEW_PASSWORD_CONFIRM')}
                        </div>

                        <Form.Item
                            name="confirmNewPassword"
                            rules={[
                                { required: true, message: displayMessage('DISPLAY_NEW_PASSWORD_CONFIRM') },
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(displayMessage('PASSWORD_MUST_BE_EQUAL'));
                                    },
                                }),
                            ]}
                            style={{ marginBottom: 25 }}
                        >
                            <SL_Input
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                type="password"
                                placeholder={displayMessage('ENTER_NEW_PASSWORD_CONFIRM')}
                            />
                        </Form.Item>
                    </div>
                </ConfigProvider>

                {/* {errorLogin && <span style={{ color: 'red', textAlign: 'center', width: '100%' }}>{errorLogin}</span>} */}

                <Form.Item hasFeedback style={{ marginBottom: 10, marginTop: 5 }}>
                    <SL_Button
                        type="primary"
                        style={{
                            width: "100%",
                            fontWeight: 'bold',
                            textShadow: '0px 0px 5px #666',
                        }}
                        htmlType="submit"
                    >
                        {displayMessage('CONFIRM_CHANGE_PASSWORD')}
                    </SL_Button>
                </Form.Item>
            </Form>
        </>
    )
}